export const COMPANY_NAME = 'companyName';
export const FLEET_ACCOUNT_NUMBER = 'fleetAccountNumber';
export const IS_VALID_FLEET_COMPANY = 'isValidFleetCompany';
